import QueryBuilderCustomUtils from 'components/queryBuilder/query-builder/sqlQueryBuilder/custom_utils/QueryBuilderCustomUtils';

const applyJsonLogic = (expression, config) => {
  if (expression && Object.keys(expression).length > 0) {
    return QueryBuilderCustomUtils.getJsonLogic(expression, config) ===
      undefined
      ? {}
      : QueryBuilderCustomUtils.getJsonLogic(expression, config);
  }
  return {};
};

export default applyJsonLogic;
